import { create } from 'zustand'

interface PermissionsState {
  /** null = not yet loaded (optimistic: show buttons enabled) */
  actions: string[] | null
  fullAccess: boolean
  setActions: (actions: string[]) => void
  setFullAccess: () => void
  reset: () => void
}

export const usePermissionsStore = create<PermissionsState>((set) => ({
  actions: null,
  fullAccess: false,
  setActions: (actions) => set({ actions, fullAccess: false }),
  setFullAccess: () => set({ actions: [], fullAccess: true }),
  reset: () => set({ actions: null, fullAccess: false }),
}))
